module.exports = __webpack_public_path__ + "fonts/VaIcons.38f74e1c.eot";